<template>
  <div class="labeled-select-input">
    <InputLabel :input-id="inputId" :label="label" />
    <SelectInput
      ref="selectInput"
      :value="value"
      :options="options"
      :placeholder="placeholder"
      :is-disabled="isDisabled"
      :label-key="labelKey"
      :value-key="valueKey"
      :icon-color="iconColor"
      :error-messages="errorMessages"
      v-on="$listeners"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import SelectInput from '../select-input';
import { randomId } from '@/shared/lib/utils';
import { InputLabel } from '@/shared/ui/form';

export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    iconColor: {
      type: String,
      default: '#71717A',
    },
    emptyText: {
      type: String,
      default: 'No options available'
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [ randomId ],
  components: { InputLabel, SelectInput },
  computed: {
    inputId() {
      return `select-${this.generateRandomId()}`;
    },
    getSelect() {
      return this.$refs.selectInput;
    },
  },
};
</script>
